// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brand_logo_container[data-v-86a49b8a]{top:-75px;border-radius:50%;box-shadow:0 0 16px 0 rgba(0,0,0,.1);background-color:#fff;padding:10px;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
